import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

// styles
import useStyles from '../styles';

// components
import { Typography } from '../../../components/Wrappers/Wrappers';

// form attributes
import { impressionMethod, scanMethod, transferMethod } from '../helpers/form';

const CaseMethod = ({ newOrder, methodClicked }) => {
    const classes = useStyles();

    const Scan = () => (
        <Card
            className={newOrder.method === scanMethod ? classes.methodCardClicked : classes.methodCard}
            onClick={methodClicked(scanMethod)}
        >
            <CardContent>
                <Typography variant="h6" weight="bold" style={{ marginBottom: 15 }}>
                    3D Scan - Upload Files
                </Typography>

                <Typography>I have an intraoral 3D scanner and want to upload my patient files</Typography>
            </CardContent>
        </Card>
    );

    const Transfer = () => (
        <Card
            className={newOrder.method === transferMethod ? classes.methodCardClicked : classes.methodCard}
            onClick={methodClicked(transferMethod)}
        >
            <CardContent>
                <Typography variant="h6" weight="bold" style={{ marginBottom: 15 }}>
                    3D Scan - Send via Scanner
                </Typography>

                <Typography>I have a 3D scanner and will send the files directly from my scanner</Typography>

                <Typography className={classes.noteText} style={{ marginTop: 10, fontStyle: 'italic' }}>
                    A Smile Academy admin will download and process your files to complete your order.
                </Typography>
            </CardContent>
        </Card>
    );

    const Impression = () => (
        <Card
            className={newOrder.method === impressionMethod ? classes.methodCardClicked : classes.methodCard}
            onClick={methodClicked(impressionMethod)}
        >
            <CardContent>
                <Typography variant="h6" weight="bold" style={{ marginBottom: 15 }}>
                    Traditional Impression
                </Typography>

                <Typography>I have a traditional impression that I will send to Smile Academy</Typography>

                <Typography className={classes.noteText} style={{ marginTop: 10, marginBottom: 10 }}>
                    <strong>Instructions:</strong> Please pour the impression with stone and provide bite registration.
                </Typography>

                <Typography className={classes.noteText}>
                    <strong>Send to:</strong> PO Box 355, Lutwyche, QLD, 4030, Australia.
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <>
            <Scan />
            <Transfer />
            <Impression />
        </>
    );
};

export default CaseMethod;
